module.exports = __webpack_public_path__ + "img/r6.8fe974b7.png";